<ng-container *ngTemplateOutlet="currentTemplate; context: context"></ng-container>

<ng-template #template_default let-title="title">

    <div style="page-break-inside: avoid">
        <h5>{{ title}}</h5>
    </div>

</ng-template>

<ng-template #template_mobile let-title="title">

    <div style="page-break-inside: avoid">
        <h5>{{title}}</h5>
    </div>

</ng-template>